export default __webpack_public_path__ + "bb5912df3c26fcae03592730069dbb0b.png";